<template lang="pug">
.container(id="CreateContentEditionForm-container")
  h4 {{$t('Rename local playlists')}}
  hr.header
  section.section-container
    section(v-if='status')
      p {{ $t('Content rename is in progress. You cannot start content rename process, until current is done.') }}
    section(v-if='!status')
      p {{ $t(`All local playlists will be renamed.`) }}
      hr.header
      section.center
        p {{$t('Please provide rename rules. You must provide at least 3 characters for both inputs. If you leave "search for" blank, a suffix to names will be added.')}}
        el-input.el-input(
          id="CreateContentEdition-searchString",
          ref='searchString',
          v-model='searchString',
          type="text",
          style="width: 200px;",
          :placeholder='$t("search for")',
        )
        span &nbsp;
        font-awesome-icon.linker-icon(icon="arrow-right")
        span &nbsp;
        el-input.el-input(
          id="CreateContentEdition-replaceString",
          ref='replaceString',
          v-model='replaceString',
          type="text",
          style="width: 200px",
          :placeholder='$t("replace with")',
        )
    .create-button-row
      el-button(id="CreateContentEditionForm-CreateButton", style='width: 100%;' :type="status ? 'warning' : 'success'", @click='submitCreate', :disabled = '!dataValid && !status')
        span(v-if='status && status.i !== status.length') {{ $t('Done ') + status.i + $t(' of ') + status.length + ' - ' + status.name }} &nbsp;
          font-awesome-icon.fa-pulse(icon="spinner")
        span(v-if='status && status.i === status.length') {{ $t('Done renaming content. Reload browser.') }} &nbsp;
          font-awesome-icon(icon="retweet")
        span(v-if='!status') {{ $t('Rename local content') }} &nbsp;
          font-awesome-icon(v-if='!status', icon="exchange-alt")
  </template>

<script>
import Vue from 'vue'
import testUtils from '../Common/textUtils.mixin'

export default {
  mixins: [testUtils],
  async created () {
    Vue.$io.socket.off('Rename_Content_Progress')
    Vue.$io.socket.on('Rename_Content_Progress', data => {
      this.status = data
    })
  },
  data () {
    return {
      file: null,
      errors: [],
      searchString: '',
      replaceString: '',
      changeMoment: undefined,
      status: undefined
    }
  },
  watch: {
    params: async function (newParams, oldParams) {
    }
  },
  methods: {
    async submitCreate () {
      if (this.status && this.status.i === this.status.length) window.location.reload()
      if (this.status) return
      await Vue.axios.post('medium/renameLocalContent', {
        searchString: this.searchString,
        replaceString: this.replaceString
      })
        .then(response => {
          return response.data
        })
    }
  },
  computed: {
    dataValid () {
      return this.replaceString.length >= 3
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.create-button-row {
  margin-top: 50px;
  .fa-pulse {
    color: white;
  }
}
.section-container {
  margin-left: 50%;
  width: 500px;
  transform: translate(-250px, 0px);;
}
.existing-extension-section {
  display: flex;
  align-items: center;
  flex-direction: column;
  .advice {
    color: $--color-text-secondary;
  }
  .existing-extension-row {
    display: flex;
    min-height: 30px;
    align-items: center;
    border-bottom: $--border-light;
    &.isSelected {
      background-color: $--background-color-selected;
    }
    .cell {
      font-size: $--font-size-base;
      padding: 10px;
      &.header {
        color: $--color-text-secondary;
      }
      &.name {
        width: 160px;
      }
      &.description {
        width: 750px;
      }
      &.version {
        width: 50px;
      }
      &.global {
        width: 150px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/MassRenameLocalContent.vue